import { combineReducers } from 'redux';
export const SET_SHOW_DRAWER = 'SET_SHOW_DRAWER';
export const ActionsCardDrawer = {
  ShowDrawer(showDrawer: boolean) {
      return { type: SET_SHOW_DRAWER, show: showDrawer };
  }
}
const drawerCart = (state = false, action:any) => {
  switch (action.type) {
   
    case SET_SHOW_DRAWER:
      state=action.show;
      return state;
    default:
      return state;
  }
};

export const drawerVisible = (state:any) => state.drawerCart;

export default combineReducers({ drawerCart });
